var l = Object.defineProperty;
var d = (o, i, e) => i in o ? l(o, i, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[i] = e;
var s = (o, i, e) => (d(o, typeof i != "symbol" ? i + "" : i, e), e);
import { fabric as n } from "fabric";
import { LeaderLine as y } from "./index.es249.js";
import { StatusOuterBox as S } from "./index.es250.js";
import { SourcePoint as f } from "./index.es251.js";
class Y extends n.Group {
  constructor(e) {
    const t = e.offsetXYFromSource || {
      x: 0,
      y: 50
    }, r = {
      left: e.projectedXYSource.x - t.x,
      top: e.projectedXYSource.y - t.y,
      scaleX: e.fabricObjScale,
      scaleY: e.fabricObjScale,
      originX: "center",
      originY: "center",
      hasBorders: !1,
      hasControls: !1,
      hasRotatingPoint: !1,
      visible: e.visible,
      perPixelTargetFind: e.perPixelTargetFind
    };
    super(e.children, r);
    s(this, "objType", "CalloutBox");
    s(this, "originMouseDelta");
    s(this, "shouldBeSelected", !1);
    s(this, "isSelectable", !0);
    s(this, "draggable", !1);
    s(this, "SelectStatuses", [
      "drag",
      "dragStart",
      "idle",
      "select",
      "selectedPOI"
    ]);
    s(this, "hasSourcePoint", !0);
    s(this, "hasLeaderLine", !0);
    s(this, "hasStatusOuterBox", !0);
    s(this, "sourcePoint");
    s(this, "leaderLine");
    s(this, "statusOuterBox");
    // Controlled by props
    s(this, "combinedLayerId");
    s(this, "layerGroupId");
    s(this, "subLayerId");
    s(this, "status");
    s(this, "styleType");
    s(this, "projectedXYSource");
    s(this, "offsetXYFromSource");
    s(this, "fabricObjScale");
    s(this, "map");
    this.layerGroupId = e.layerGroupId, this.subLayerId = e.subLayerId, this.combinedLayerId = e.combinedLayerId, this.styleType = e.styleType, this.projectedXYSource = e.projectedXYSource, this.offsetXYFromSource = t, this.fabricObjScale = e.fabricObjScale, this.status = e.status || "idle", this.draggable = e.draggable || !1, this.originMouseDelta = {
      x: 0,
      y: 0
    }, this.map = e.map, this.sourcePoint = this.getSourcePoint(), this.leaderLine = this.getLeaderLine(), this.statusOuterBox = this.getStatusOuterBox(), this.updateStatus(this.status);
  }
  calculateOriginMouseDelta({ x: e, y: t }) {
    this.originMouseDelta.x = this.getCenterPoint().x - e, this.originMouseDelta.y = this.getCenterPoint().y - t;
  }
  resetOriginMouseDelta() {
    this.originMouseDelta.x = 0, this.originMouseDelta.y = 0;
  }
  getSourcePoint() {
    if (!this.hasSourcePoint)
      return null;
    const { x: e, y: t } = this.projectedXYSource, r = new f({
      left: e,
      top: t,
      styleType: this.styleType,
      visible: this.visible
    });
    return this.sourcePoint = r, r;
  }
  getLeaderLine() {
    if (!this.hasLeaderLine)
      return null;
    const { x: e, y: t } = this.projectedXYSource, { x: r, y: u } = this.offsetXYFromSource, a = e - r, h = t - u, c = new y([e, t, a, h], {
      styleType: this.styleType,
      visible: this.visible
    });
    return this.leaderLine = c, c;
  }
  getStatusOuterBox() {
    if (!this.hasStatusOuterBox)
      return null;
    const e = new S(this, {
      styleType: this.styleType
    });
    return this.statusOuterBox = e, e;
  }
  getFabricObjects() {
    return [this.sourcePoint, this.leaderLine, this.statusOuterBox, this].filter(
      (e) => e
    );
  }
  updateStatus(e) {
    var r, u, a;
    let t = this.SelectStatuses.includes(e) ? e : "idle";
    switch (t) {
      case "drag":
        this.status = "drag";
        return;
      case "dragStart":
        this.status = "dragStart";
        break;
      case "select":
        this.status = "select";
        break;
      case "selectedPOI":
        this.status = "selectedPOI";
        break;
      default:
        this.status = "idle";
    }
    return (r = this.leaderLine) == null || r.updateStyle(this.styleType, t), (u = this.sourcePoint) == null || u.updateStyle(this.styleType, t), (a = this.statusOuterBox) == null || a.updateStyle(this.styleType, t), t;
  }
  updateVisible(e) {
    var t, r;
    !e && this.status !== "idle" && this.updateStatus("idle"), this.visible = e, (t = this.sourcePoint) == null || t.set({
      visible: e
    }), (r = this.leaderLine) == null || r.set({
      visible: e
    }), this.set({ visible: e });
  }
  updateStyleType(e) {
    this.styleType = e, this.updateStatus(this.status);
  }
  bringToFront() {
    var e, t;
    return super.bringToFront(), (e = this.sourcePoint) == null || e.sendToBack(), (t = this.leaderLine) == null || t.sendToBack(), this;
  }
  updatePosition({ source: e, draggedPos: t }) {
    e && (this.projectedXYSource = e), t && (this.offsetXYFromSource.x = this.projectedXYSource.x - t.x - this.originMouseDelta.x, this.offsetXYFromSource.y = this.projectedXYSource.y - t.y - this.originMouseDelta.y), this.left = this.projectedXYSource.x - this.offsetXYFromSource.x, this.top = this.projectedXYSource.y - this.offsetXYFromSource.y, this.setCoords(), this.statusOuterBox && (this.statusOuterBox.left = this.left, this.statusOuterBox.top = this.top, this.statusOuterBox.setCoords()), this.sourcePoint && (this.sourcePoint.set({
      left: this.projectedXYSource.x,
      top: this.projectedXYSource.y
    }), this.sourcePoint.setCoords()), this.leaderLine && (this.leaderLine.set({
      x1: this.projectedXYSource.x,
      x2: this.projectedXYSource.x - this.offsetXYFromSource.x,
      y1: this.projectedXYSource.y,
      y2: this.projectedXYSource.y - this.offsetXYFromSource.y
    }), this.leaderLine.setCoords());
  }
}
export {
  Y as GenericCalloutBox
};
//# sourceMappingURL=index.es170.js.map
